import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

// Components
import Icon from "components/Stacker/components/Icon/Icon"

import "./SlickArrow.scss"

function SlickArrow({ iconName, className, onClick, ariaLabel }) {
  return (
    <button
      className={classNames("SlickArrow", className)}
      onClick={onClick}
      aria-label={ariaLabel || iconName}
    >
      <Icon iconName={iconName} />
    </button>
  )
}

SlickArrow.propTypes = {
  iconName: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string,
}

export default SlickArrow
